import { Options, Vue } from 'vue-class-component';
import PageTitleComponent from '@/sharedcomponents/pageComponents/pageTitle/PageTitleComponent.vue';
import { AcceptPage } from '@/cms/definitions/content-types';
import store from '@/store/store';
import CookieFooter from '@/sharedcomponents/pageComponents/cookieFooter/cookieFooter.vue';
import VerticalContainerComponent from './VerticalContainerComponent.vue';
import { getDomain, getQueryParameter, handleIdleLogout, isDevelop } from '@/services/environmentService';
import { PROPOSAL_LOADED } from '@/store/modules/ProposalContext';
import { mapState } from 'vuex';
import { PropType } from 'vue';

@Options({
	name: 'DigitalAcceptComponent',
	components: {
		PageTitleComponent,
		VerticalContainerComponent,
		CookieFooter,
	},
	computed: mapState<any>({
		hasError: (state) => store.state.hasError,
		mockedDataLoaded: (state) => store.state.mockedDataLoaded,
	}),
	props: {
		model: Object as PropType<AcceptPage>,
	},
})
export default class DigitalAcceptComponent extends Vue {
	public model: AcceptPage; // epi contentModel
	public usabillaBlock: any = null;
	public renderPage = false;
	public showHeadline = false;
	public headline = '...';
	public isDevelop = isDevelop;

	public domain = getDomain();

	public hasError!: boolean;
	public mockedDataLoaded!: boolean;
	public debug = false;

	public beforeCreate() {
		handleIdleLogout(this.domain.url, 30);
	}

	public beforeMount() {
		store.state.showSpinner = true;

		this.headline = this.model.headline;

		store.subscribeAction((action, state) => {
			if (action.type === PROPOSAL_LOADED) {
				setTimeout(() => {
					this.showHeadline = true;
				}, 100);
			}
		});
		this.renderPage = true;

		if (isDevelop && getQueryParameter('mock')) {
			this.debug = true;
		}
	}
}
